"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagList = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/core/components/Button");
var _Tag = require("b2b-components/core/components/TagList/TagList/Tag");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
require("./TagList.scss");
const TagList = _ref => {
  let {
    className,
    onDismissAll,
    onTagDismiss,
    text,
    tags
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('cds-TagList', className)
  }, tags.map(_ref2 => {
    let {
      value,
      label,
      iconName,
      onClick,
      isDismissible
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Tag.Tag, {
      key: (0, _key.createKey)(value, label),
      label: label,
      iconName: iconName,
      onDismiss: () => onTagDismiss(value),
      onClick: onClick,
      isDismissible: isDismissible
    });
  }), tags.length > 1 && onDismissAll && text.dismiss && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-Tag--Dismiss"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: onDismissAll,
    styleType: _Button.BUTTON_STYLE_TYPE.ghost,
    size: _Button.BUTTON_SIZE.small,
    dataAttributes: {
      'data-testid': 'resetTagListButton'
    }
  }, text.dismiss)));
};
exports.TagList = TagList;
//# sourceMappingURL=TagList.js.map